import React from "react";
import { UserFeedsType } from "../../types";
import { Tooltip } from "..";

type UserModalActivityReaderProps = {
  userFeed: UserFeedsType | undefined;
  // feedLikes: FeedLikeType | undefined;
  loadings: boolean;
  modalRemove: boolean;
};

const UserModalActivityReader: React.FC<UserModalActivityReaderProps> = ({
  userFeed,
  modalRemove,
  loadings,
}) => {
   const commentersSet = new Set();

  const commenters = userFeed?.comments.map((comment) => {
    const creatorName = `${comment.creator.firstName} ${comment.creator.lastName}`;

    // Check if the user ID is already in the Set
    if (!commentersSet.has(comment.creator.id)) {
      // If not, add it to the Set and return the commenter's name
      commentersSet.add(comment.creator.id);
      return creatorName;
    }

    // If the user ID is already in the Set, return an empty string
    return "";
  });

  // Filter out the empty strings from the commenters array
  const uniqueCommenters = commenters?.filter((commenter) => commenter !== "");

  //This is used to set the likes Display

  const totalLikes = userFeed?.feedLikes?.length || 0;
  const totalComments = userFeed?.comments && userFeed?.comments?.length;

  return (
    <div className="w-full flex justify-between text-[#646464] font-Poppins text-[8px] mb-1 h-5 mx-auto lg:text-[14.7px] lg:font-SegoeUI font-normal lg:px-4">
      <div className="flex text-searchCol w-[64%]">
      {loadings ? (
          <div className="flex">
            {loadings && modalRemove
              ? totalLikes > 1
                ? `${totalLikes - 1} likes`
                : totalLikes === 1 && ""
              : `${totalLikes + 1} like${totalLikes > 1 ? "s" : ""}`}
          </div>
        ) : (
          userFeed &&
          userFeed?.feedLikes?.length > 0 && (
            <div className="flex">{`${totalLikes} like${totalLikes > 1 ? "s" : ""}`}</div>
          )
        )}
      </div>
      <div className="flex gap-1 w-[35%] justify-end  text-searchCol">
        {userFeed?.comments && userFeed.comments.length > 0 && (
          <div className="flex gap-1 cursor-pointer">
            <div className="flex cursor-pointer" />
            <Tooltip
              list={uniqueCommenters}
            >{`${totalComments} comments`}</Tooltip>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserModalActivityReader;
